import { IconProps } from './types';

export const IconRevealOff = ({ height = '24', width = '24', ...props }: IconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.7071 5.70711C20.0976 5.31658 20.0976 4.68342 19.7071 4.29289C19.3166 3.90237 18.6834 3.90237 18.2929 4.29289L15.8728 6.71296C14.6384 6.23502 13.3094 6 12 6C8.35417 6 4.55737 7.82187 3.06845 11.6364C2.97718 11.8702 2.97718 12.1298 3.06845 12.3636C3.73954 14.0829 4.87947 15.3974 6.2631 16.3227L4.29289 18.2929C3.90237 18.6834 3.90237 19.3166 4.29289 19.7071C4.68342 20.0976 5.31658 20.0976 5.70711 19.7071L8.12717 17.287C9.36164 17.765 10.6906 18 12 18C15.6458 18 19.4426 16.1781 20.9316 12.3636C21.0228 12.1298 21.0228 11.8702 20.9316 11.6364C20.2605 9.91711 19.1205 8.60263 17.7369 7.67732L19.7071 5.70711ZM14.2907 8.29512C13.5554 8.09933 12.7827 8 12 8C9.07938 8 6.29691 9.38316 5.08641 12C5.65992 13.2398 6.58629 14.2027 7.71303 14.8728L9.29237 13.2934C9.10495 12.9018 9 12.4631 9 12C9 10.3431 10.3431 9 12 9C12.4631 9 12.9018 9.10495 13.2934 9.29237L14.2907 8.29512ZM14.7076 10.7066L16.287 9.12724C17.4137 9.79731 18.3401 10.7602 18.9136 12C17.7031 14.6168 14.9206 16 12 16C11.2173 16 10.4446 15.9007 9.70933 15.7049L10.7066 14.7076C11.0982 14.895 11.5369 15 12 15C13.6569 15 15 13.6569 15 12C15 11.5369 14.895 11.0982 14.7076 10.7066Z"
                fill="currentColor"
            />
        </svg>
    );
};
